import { render, staticRenderFns } from "./invites.vue?vue&type=template&id=fe1457ec&scoped=true&"
import script from "./invites.vue?vue&type=script&lang=js&"
export * from "./invites.vue?vue&type=script&lang=js&"
import style0 from "./invites.vue?vue&type=style&index=0&id=fe1457ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe1457ec",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemGroup } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VCard,VList,VListItem,VListItemContent,VListItemGroup,VListItemTitle,VSkeletonLoader})
